jQuery(function($) {
  var body = $('body');
  $('.header__menu-toggle').attr('aria-expanded', 'false');
  $('.header__search-toggle').attr('aria-expanded', 'false');
  $('.nav').attr('aria-expanded', 'false');
  $('.nav').attr('aria-hidden', 'true');
  $('.nav a').attr('tabindex', '-1');
  $('.search__button').attr('aria-hidden', 'true');
  $('.search__input').attr('aria-hidden', 'true');
  $('.search__button').attr('tabindex', '-1');
  $('.search__input').attr('tabindex', '-1');

  //

  var openNavMenu = function() {
    body.addClass('menu-active');
    $(this).attr('aria-expanded', 'true');
    $('.nav').attr('aria-expanded', 'true');
    $('.nav').attr('aria-hidden', 'false');
    $('.nav a').attr('tabindex', '0');

    var delay = 0;
    var duration = 0;
    $('.nav__animate').each(function(index, item) {
      $(item).addClass('animated');
      $(item).css({
        'transform': 'translateY(0)',
        'opacity': 1,
        'transition-delay': delay + 's',
        'transition-duration': duration + 's'
      });
      delay += 0.1;
      duration += 0.1;
    });
  }

  var closeNavMenu = function() {
    body.removeClass('menu-active');
    $(this).attr('aria-expanded', 'false');
    $('.nav').attr('aria-expanded', 'false');
    $('.nav').attr('aria-hidden', 'true');
    $('.nav a').attr('tabindex', '-1');
    $('.nav__animate').each(function(index, item) {
      $(item).removeClass('animated').removeAttr("style");
    });
  }

  var toggleMenu = function(e) {
    e.preventDefault();
    setTimeout(function() {
      if (body.hasClass('menu-active')) {
        closeNavMenu();
      } else {
        openNavMenu();
      }
      if (body.hasClass('search-active')) {
        body.removeClass('search-active');
      }
    }, 200);
  }

  //

  var openSearch = function() {
    body.addClass('search-active');
    $(this).attr('aria-expanded', 'true');
    $('.header__logo a').attr('aria-hidden', 'true');
    $('.search__button').attr('aria-hidden', 'false');
    $('.search__input').attr('aria-hidden', 'false');
    $('.search__button').attr('tabindex', '0');
    $('.search__input').attr('tabindex', '0');
    $('.search__input').focus();
  }

  var closeSearch = function() {
    body.removeClass('search-active');
    $(this).attr('aria-expanded', 'false');
    $('.search__button').attr('aria-hidden', 'true');
    $('.search__input').attr('aria-hidden', 'true');
    $('.search__button').attr('tabindex', '-1');
    $('.search__input').attr('tabindex', '-1');
    $('.header__logo a').attr('aria-hidden', 'false');
  }

  var toggleSearch = function(e) {
    e.preventDefault();
    if (body.hasClass('search-active')) {
      closeSearch();
    } else {
      openSearch();
    }
    if (body.hasClass('menu-active')) {
      closeNavMenu();
    }
  }

  //

  $('.page').on('click', function() {
    setTimeout(function() {
      if (body.hasClass('menu-active')) {
        closeNavMenu();
      } else if (body.hasClass('search-active')) {
        closeSearch();
      }
    }, 200);
  });

  $('.header__menu-toggle').on('click', toggleMenu);
  $('.header__search-toggle').on('click', toggleSearch);



  $(window).scroll(function() {
    if ($(this).scrollTop() >= 600 && hasClass(document.getElementsByTagName("header")[0], "header--sticky-home")) {
      $('header').addClass('header--sticky');
    } else if (hasClass(document.getElementsByTagName("header")[0], "header--sticky-home")) {
      $('header').removeClass('header--sticky');
    };
  });


  // element variables
var els = {
  header: document.querySelector('header')
}

// init varibles
var didScroll,
  lastScrollTop = 0,
  delta = 5,
  navbarHeight = els.header.offsetHeight;

// get current scroll
function getCurrentScroll() {
  return window.pageYOffset || document.documentElement.scrollTop;
}

// what happens on scroll
function menuOnScroll() {
  var currentScroll = getCurrentScroll();

  if (Math.abs(lastScrollTop - currentScroll) <= delta)
    return;

  if (currentScroll > lastScrollTop && currentScroll > navbarHeight) {
    els.header.classList.add('nav-hidden');
  } else {
    if (currentScroll + window.innerHeight < document.documentElement.scrollHeight) {
      els.header.classList.remove('nav-hidden');
    }
  }

  lastScrollTop = currentScroll;
}

function hasClass(ele,cls) {
     return ele.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)'));
}

// show menu when mouse hovers menu area
document.body.onmousemove = function(e) {
  var pageY = e.pageY || e.clientY,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop,
    trigger_area = pageY - scrollTop,
    trigger_threshold = navbarHeight;

  if (trigger_area <= trigger_threshold) {
    els.header.classList.remove('nav-hidden');
  }
};

// set on scroll behavior
window.onscroll = function() {
  if(!hasClass(document.getElementsByTagName("body")[0], "menu-active")){
    didScroll = true;
  }
};
setInterval(function() {
  if (didScroll) {
    menuOnScroll();
    didScroll = false;
  }
}, 250);

});